import CubeJS from "@cubejs-client/core";

export const cubeJSClient = CubeJS(
  process.env.REACT_APP_CUBE_API_KEY,
  { apiUrl: process.env.REACT_APP_CUBE_API_URL }
);
